<template>
  <div v-show="visible">
    <div class="mask"></div>
    <div class="subject-end">
      <div class="bg-content"></div>
      <div class="dialog-content">
        <p class="title">温馨提示</p>
        <div class="content-body">
          <h2>考试已经结束，请您离开考场！</h2>
          <span class="orange"></span>
          <div class="option">
            <a href="javascript:void(0)"
              class="closeReal"
              @click="closeDialog">关闭</a>
            <a href="javascript:void(0)"
              class="close"
              @click="viewResults">直接查看成绩</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'subjectEnd',
  props: {
    visible: { type: Boolean },
    activity: { type: String },
    query: { type: String },
    subFlag: { type: Boolean}
  },
  methods: {
    closeDialog(){
      if(this.$route.query.flag === 'ordinary'){
        window.location.href="about:blank"
        window.close()
        return
      }
      this.$emit('update:visible', false)
      this.$router.push({name: 'examSystem', query: {siteCourseID:this.siteCourseID, courseID:this.courseID}})
    },
    viewResults() {
      this.$emit('viewResults')
    }
  },
  mounted(){
    const { siteCourseID, courseID } = this.$route.query
    this.courseID = Number(courseID)
    this.siteCourseID = Number(siteCourseID)
  }
}
</script>
